<template>

  <el-table
    class="table-xs"
    style="width: 100%"
    width="100%"
    v-if="data"
    :data="data.Ekstre"
    show-summary
    :height="Height"
    :summary-method="TableFooter"
  >
    <el-table-column
      label="Tarih"
      prop="Tarih"
      width="100">
    </el-table-column>
    <el-table-column
      label="Türü"
      prop="Tur"
      width="100">
    </el-table-column>
    <el-table-column
      label="Evrak No"
      prop="eNo"
      width="100">
    </el-table-column>
    <el-table-column
      label="Açıklama"
      prop="Aciklama"
    >
    </el-table-column>
    <el-table-column
      label="Emanet"
      prop="Emanet"
      width="100"
      align="right">
    </el-table-column>
    <el-table-column
      label="Zam"
      prop="Zam"
      width="100"
      align="right">
    </el-table-column>
    <el-table-column
      label="Borç"
      prop="Borc"
      width="100"
      align="right">
    </el-table-column>
    <el-table-column
      label="Ödenen"
      prop="Odenen"
      width="100"
      align="right">
    </el-table-column>
    <el-table-column
      label="Kalan"
      prop="Kalan"
      width="100"
      align="right">
    </el-table-column>
  </el-table>

</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      Height: window.innerHeight - 250,
      tableData: []
    }
  },
  methods: {
    TableFooter() {
      const sums = [];
      sums[4] = this.data.AltToplam.Emanet;
      sums[5] = this.data.AltToplam.Zam;
      sums[6] = this.data.AltToplam.Borc;
      sums[7] = this.data.AltToplam.Odenen;
      sums[8] = this.data.AltToplam.Kalan;

      return sums;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Raporlama/RaporlamaKisiEkstre.vue